import React from 'react';
import { Link } from 'react-router-dom';
export function FreeTrialAudiences() {
  return <section className="py-24 bg-off-white" data-id="element-1483">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1484">
        <div className="grid lg:grid-cols-3 gap-6" data-id="element-1485">
          {[{
          title: 'Kids',
          copy: 'Mini Troopers (3–5) and Kids Taekwondo (6+). Confidence, focus, discipline, respect – built through real Taekwondo training.',
          href: '/karate-kids-classes.html',
          cta: 'Kids Classes'
        }, {
          title: 'Adults',
          copy: 'Beginner-friendly adult Taekwondo. Fitness, skill, and stress relief — engaging enough that you actually keep showing up.',
          href: '/karate-adult-classes',
          cta: 'Adult Classes'
        }, {
          title: 'Families',
          copy: 'Train together on the same mat. Parents and kids share a positive activity, earn belts together, and grow as a family.',
          href: '/FamilyKarateClasses.html',
          cta: 'Family Classes'
        }].map((c, i) => <div key={i} className="bg-paper border border-subtle-gray rounded-2xl p-8 flex flex-col gap-4" data-id="element-1486">
              <h3 className="text-2xl text-ink leading-tight" data-id="element-1487">
                Classes for {c.title}
              </h3>
              <p className="text-gray-warm leading-relaxed flex-grow" data-id="element-1488">
                {c.copy}
              </p>
              <Link to={c.href} className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-1489">
                Explore {c.cta} →
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}